import { GO_TO_FEEDBACK_OPTIONS } from "@/constants/feedback";
import { cn } from "@/utils/cn";
import { IonRadio, IonRadioGroup } from "@ionic/react";

interface FeedbackRadioGroupProps {
  selectedOption: string;
  handleOptionChange: (value: string) => void;
}

export function FeedbackRadioGroup({
  selectedOption,
  handleOptionChange,
}: FeedbackRadioGroupProps) {
  return (
    <IonRadioGroup
      value={selectedOption}
      onIonChange={(e) => handleOptionChange(e.detail.value)}
    >
      <div className="space-y-4">
        {GO_TO_FEEDBACK_OPTIONS.map((option, index) => (
          <div
            key={option.value}
            className={cn(
              "flex flex-row items-start gap-4 p-4 rounded-xl border-2 cursor-pointer transition-all bg-white ",
              selectedOption === option.value
                ? "border-secondary-default"
                : "border-gray-200 hover:border-gray-300",
            )}
            onClick={() => handleOptionChange(option.value)}
          >
            <IonRadio
              value={option.value}
              className="mt-1 flex-shrink-0"
              color="primary"
            />
            <div className="flex-1">
              <div className="text-sm font-medium text-gray-900 mb-1">
                {String.fromCharCode(97 + index)}. {option.title}
              </div>
              <div className="text-xs text-gray-600 leading-relaxed">
                {option.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </IonRadioGroup>
  );
}
